<!-- Navbar -->
<nav class="navbar navbar-expand-lg navbar-dark main-menu fixed-top">
    <div class="container-fluid">
        <a href="#">
            <img src="images/home/nordnative-logo-square-dark-background.png" style="height: 40px;" />
        </a>

        <!-- <a class="navbar-brand" href="#">NordNative OÜ</a> -->
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
            aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav ms-auto" (click)="closeMobileMenu()">
                <li class="nav-item">
                    <a class="nav-link active" aria-current="page" [routerLink]="['']">Home</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['about']">About</a>
                </li>
                <!--
                <li class="nav-item">
                <a class="nav-link" [routerLink]="['products']">Products</a>
                </li>
                -->
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['products']">Products</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['contact']">Contact</a>
                </li>
                <li class="nav-item">
                    &nbsp;&nbsp;&nbsp;
                </li>
                <li class="nav-item">
                    <a href="tel:{{CONTACT_US_PHONE_MAIN}}" class="btn btn-dark">
                        <i class="bi bi-telephone-fill"></i> Call Us
                    </a>
                </li>
            </ul>
        </div>
    </div>
</nav>

<div class="col-xs-12" style="height:50px;"></div>
